import req from "../http";

const hr = {
  // 取得 待面談
  getInInterviewPaging(params) {
    return req("get", "/Progress/ByInInterview/paging", params);
  },

  //  取得 已面談
  getInterviewedPaging(params) {
    return req("get", "/Progress/ByInterviewed/paging", params);
  },

  //  取得 面談結果
  getInterviewResultPaging(params) {
    return req("get", "/Progress/InterviewResult/paging", params);
  },

  //  取得 任用結果
  getAppointmentResultPaging(params) {
    return req("get", "/Progress/AppointmentResult/paging", params);
  },

  // 報到查詢
  getOnBoardPaging(params) {
    return req("get", "/Progress/OnBoard/paging", params);
  },
};

export default hr;